import { PayloadAction } from '@reduxjs/toolkit';

import { EditMemberType } from 'types/people/editMemberProfile';
import { SetFieldType } from 'types/reduxTypes/ActionTypes/PeopleTypes';
import { DataPayload } from 'types/reduxTypes/ActionTypes';
import { defaultMember } from 'redux/utils/defaultStates/MemberDefaultState';
import { types } from './actions';

type EditMemberState = {
  member: EditMemberType,
  skillsShowError: boolean,
  hobbiesShowError: boolean,
  jobFunctionsShowError: boolean,
}

const initialState: EditMemberState = {
  member: {
    ...defaultMember,
    skills: '',
    hobbies: '',
    jobFunctions: '',
    numberOfKids: 0,
    gender: 0,
    hasEmiratesId: 0,
    nationalityId: 0,
    passport: '',
    visa: '',
  },
  skillsShowError: false,
  hobbiesShowError: false,
  jobFunctionsShowError: false,
};

const handleSetAll = (state: EditMemberState, payload: DataPayload<EditMemberType>) => ({
  ...state, member: payload.data,
});

const handleSetField = (state: EditMemberState, payload: SetFieldType) => ({
  ...state, member: { ...state.member, [payload.field]: payload.value },
});

const handleSetLogo = (state: EditMemberState, payload: DataPayload<string | Blob>) => ({
  ...state, member: { ...state.member, emiratesId: payload.data },
});

const handleSetShowError = (state: EditMemberState, payload: SetFieldType) => ({
  ...state, [`${payload.field}ShowError`]: payload.value,
});

const handleSetPassport = (state: EditMemberState, payload: DataPayload<string | Blob>) => ({
  ...state, member: { ...state.member, passport: payload.data },
});

const handleSetVisa = (state: EditMemberState, payload: DataPayload<string | Blob>) => ({
  ...state, member: { ...state.member, visa: payload.data },
});

const reducer = (
  state: EditMemberState,
  action: PayloadAction<DataPayload<EditMemberType | string | Blob> | SetFieldType>,
): EditMemberState => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ALL: {
      return handleSetAll(state, <DataPayload<EditMemberType>>payload);
    }
    case types.SET_FIELD: {
      return handleSetField(state, <SetFieldType>payload);
    }
    case types.SET_EMIRATES_ID_PEOPLE: {
      return handleSetLogo(state, <DataPayload<string | Blob>>payload);
    }
    case types.SHOW_ERROR: {
      return handleSetShowError(state, <SetFieldType>payload);
    }
    case types.SET_VISA: {
      return handleSetVisa(state, <DataPayload<string | Blob>>payload);
    }
    case types.SET_PASSPORT: {
      return handleSetPassport(state, <DataPayload<string | Blob>>payload);
    }
    default:
      return state;
  }
}

export { reducer, initialState };
